/* ══════════════════════════════════════════════════════════════════════
   TWS Literary Excellence Award — generated by award-src/build-shopify.py
   from award.html. Do not edit.

   ⚠ EVERY SECTION EMITS ITS OWN <script src="tws-lea.js">, so on the theme
   this file is requested once but the page carries nine section tags. The
   guard below makes the whole module run exactly once either way.
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.__twsLeaInit) return;
  window.__twsLeaInit = true;



/* ══════════════════════════════════════════════════════════════════════
   FEATURED AUTHORS — vanilla port of the handoff's DCLogic class.
   Everything is scoped to .tws-lea so the locked chrome and footer are
   never touched.

   NOT PORTED: _initRail. It drove #scrollRail, which lives in the
   handoff's own header — replaced here by the locked TWS chrome. There
   are no [data-par] elements on this page either.
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.__twsFaInit) return;
  window.__twsFaInit = true;

  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- headline type: every word rises out of its own mask ---- */
  function splitWords() {
    var heads = $$('.tws-lea h1, .tws-lea .sec-h2');
    var wrap = function (el) {
      Array.prototype.slice.call(el.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          if (!n.textContent.trim()) return;
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
            var s = document.createElement('span'); s.className = 'sw';
            var i = document.createElement('i'); i.textContent = p;
            s.appendChild(i); frag.appendChild(s);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && !n.hasAttribute('data-nosplit') &&
                   !n.classList.contains('sw') && n.tagName !== 'svg' &&
                   n.tagName !== 'BUTTON' && n.tagName !== 'A') { wrap(n); }
      });
    };
    heads.forEach(function (h) {
      if (h.getAttribute('data-split')) return;
      h.setAttribute('data-split', '1');
      wrap(h);
      var words = h.querySelectorAll('.sw');
      var fire = function () {
        words.forEach(function (w, i) { w.classList.add('on'); w.firstChild.style.animationDelay = (i * 52) + 'ms'; });
      };
      if (h.getBoundingClientRect().top < innerHeight * 0.9 || typeof IntersectionObserver === 'undefined') { fire(); return; }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { fire(); io.disconnect(); } });
      }, { threshold: 0.15 });
      io.observe(h);
    });
  }

  /* ---- the section rule draws itself in ---- */
  function initRules() {
    var rules = $$('.tws-lea .rule');
    if (!rules.length) return;
    var show = function (el) { el.style.animation = 'ruleIn .9s cubic-bezier(.22,.7,.25,1) both'; };
    if (REDUCE || typeof IntersectionObserver === 'undefined') { rules.forEach(show); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.3 });
    rules.forEach(function (r) { io.observe(r); });
    var t = setInterval(function () {
      var left = 0;
      rules.forEach(function (r) {
        if (r.style.animation) return;
        left++;
        if (r.getBoundingClientRect().top < innerHeight * 0.94) show(r);
      });
      if (!left) clearInterval(t);
    }, 300);
  }

  /* ---- reveals, with the backstop sweep ---- */
  var revealPending = [];
  /* ⚠ AN `animation: … both` IS NOT A GUARANTEE OF VISIBILITY.
     `riseS` starts at opacity:0, and `both` holds that start state until the
     animation actually runs. A card revealed by Load more was never given an
     inline opacity to clear, so if animations are frozen — a throttled tab, an
     editor iframe, reduced motion honoured at the OS level — it sits at the
     `from` frame forever. Measured: 13 of 21 cards invisible after four clicks.
     So every reveal ALSO schedules the animation away again once it can only
     have finished, which returns the element to its natural opacity:1. */
  var revealShow = function (el) {
    var kind = 'lea' + (el.getAttribute('data-rv') || 'rise').replace(/^./, function (c) { return c.toUpperCase(); });
    var d = Math.min(parseInt(el.getAttribute('data-rv-d') || '0', 10), 140);
    el.style.animation = kind + ' .5s cubic-bezier(.22,.61,.36,1) ' + d + 'ms both';
    el.style.opacity = '';
    setTimeout(function () { el.style.animation = ''; }, 620 + d);
  };
  function initReveal() {
    if (REDUCE) return;
    var els = $$('.tws-lea [data-rv]');
    if (!els.length || typeof IntersectionObserver === 'undefined') return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        revealShow(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px 12% 0px', threshold: 0 });
    els.forEach(function (el) {
      /* ⚠ a card that is hidden by `.pend` measures top:0, which would look
         "above the fold" and never get hidden — skip those; they are revealed
         when Load more un-hides them. */
      if (el.closest('.fa-card') && el.closest('.fa-card').classList.contains('pend')) { revealPending.push(el); return; }
      if (el.getBoundingClientRect().top > innerHeight * 0.96) {
        /* ⚠ never animate something taller than the screen — it is already
           filling the viewport when its reveal starts, so the whole screen
           dims and slides at once. The entry form is 1,097px tall. */
        if (el.getBoundingClientRect().height > (innerHeight || 800) * 0.85) return;
        el.style.opacity = '0'; io.observe(el); revealPending.push(el);
      }
    });

    /* the backstop — an IntersectionObserver must never be the only route back */
    var sweep = function () {
      /* ⚠ NEVER TRUST innerHeight TO BE SANE. Some embedded/backgrounded
         renderers report 0, which makes `top < innerHeight * 0.94` impossible
         to satisfy — the sweep then never fires and cards that the observer
         also missed stay invisible forever. Measured: 4 of 21 stranded. If the
         viewport height is unusable, reveal everything rather than gamble. */
      var vh = innerHeight || document.documentElement.clientHeight || 0;
      for (var i = revealPending.length - 1; i >= 0; i--) {
        var el = revealPending[i];
        var card = el.closest('.fa-card');
        if (card && card.classList.contains('pend')) continue;   // still hidden on purpose
        if (el.style.opacity !== '0') { revealPending.splice(i, 1); continue; }
        if (!vh || el.getBoundingClientRect().top < vh * 0.94) { revealShow(el); revealPending.splice(i, 1); }
      }
    };
    var queued = false;
    var onScroll = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; sweep(); });
    };
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    setInterval(sweep, 300);
    sweep();
  }

  /* ---- the load-more list ----
     Every card is in the DOM for SEO and for the structured data; the ones past
     the initial count carry `.pend{display:none}` and their images are lazy, so
     they cost nothing until revealed. */
  

  function boot() {  splitWords(); initReveal(); initRules(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* ⚠ SELF-CONTAINED ON PURPOSE. This block was originally appended AFTER
     the donor script's closing `})();`, which put it OUTSIDE that IIFE where
     `$$` does not exist. It threw a ReferenceError at parse time and every
     one of these features — the accordion, the copy button AND the unstick
     backstop — silently never ran, with nothing in the console. It now
     declares its own helper and is spliced INSIDE the IIFE as well. */
  var leaQ = function (s) { return Array.prototype.slice.call(document.querySelectorAll(s)); };
  /* ── the unstick backstop ─────────────────────────────────────────
     ⚠ NEVER OPTIONAL ON THIS PROJECT. initReveal() sets an inline opacity:0
     on everything it judges to be below the fold — and when innerHeight reads
     0 at load (a backgrounded tab, an embedded renderer) that is EVERY
     element. Recovery then depends entirely on a scroll event arriving.
     Measured on this page: all 41 [data-rv] nodes started hidden and only
     came back after a full scroll. This strips the inline opacity off
     anything still transparent after 1.8s, so the page can never sit blank
     waiting for an event that may never come. Same guard the product page
     carries; it is the fifth time this family of bug has cost a session. */
  (function () {
    var t = null;
    function unstick() {
      /* ⚠⚠ THIS USED TO REVEAL THE WHOLE PAGE AT 1.8s, AND THAT IS ITSELF A
         GLITCH. Everything still hidden — including every section the visitor
         had not scrolled to yet — had its opacity cleared with NO animation,
         so 1.8 seconds after load a screenful of content could snap in at
         once, and from then on nothing animated at all because it was already
         visible. A backstop is meant to catch what is STUCK IN FRONT OF THE
         VISITOR, not to pre-empt the reveal for the rest of the page.
         Below-the-fold elements are now left to the observer and the engine's
         own 300ms sweep, which reveal them properly, with the animation.
         ⚠ The zero-viewport case still reveals everything: if innerHeight is
         unusable (a backgrounded tab, an embedded renderer) nothing measures
         as on-screen, and that is the exact failure this guard exists for. */
      var vh = innerHeight || document.documentElement.clientHeight || 0;
      leaQ('.tws-lea [data-rv]').forEach(function (el) {
        if (parseFloat(getComputedStyle(el).opacity) >= 0.99) return;
        if (vh && el.getBoundingClientRect().top > vh) return;
        el.style.opacity = '';
        el.style.transform = 'none';
        el.style.animation = 'none';
      });
    }
    function arm() { if (t) clearTimeout(t); t = setTimeout(unstick, 1800); }
    arm();
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') arm();
    });
    addEventListener('pageshow', arm);
    /* ⚠ AND IT MUST NOT BE A ONE-SHOT. Now that the backstop only clears what
       is ON SCREEN, firing once at 1.8s would leave anything that gets stuck
       LATER — a tab backgrounded mid-scroll freezes rAF and the observer, and
       the sweep with it — invisible for the rest of the session. Re-arming on
       scroll costs one debounced timer and means the guarantee holds at every
       scroll position, not just the first. It never fires while the visitor is
       actually scrolling. */
    addEventListener('scroll', arm, { passive: true });
  })();

  /* ── accordion: one open per group ────────────────────────────────
     The handoff shipped this inside a DCLogic component that does not exist
     in a static page. Ported verbatim in behaviour: opening one panel closes
     its siblings, but only within the SAME parent, so The details and FAQ
     stay independent of each other. */
  (function () {
    var panels = leaQ('.tws-lea details.lea-cx');
    panels.forEach(function (d) {
      d.addEventListener('toggle', function () {
        var sum = d.querySelector('summary');
        if (sum) sum.setAttribute('aria-expanded', d.open ? 'true' : 'false');
        if (!d.open) return;
        panels.forEach(function (o) {
          if (o !== d && o.open && o.parentNode === d.parentNode) o.open = false;
        });
      });
    });
  })();

  /* ── a deep link into the accordion OPENS the answer ──────────────
     The mega menu now points at #eligibility, #how-to-enter and #rules,
     which are <details> rows. Landing on a closed summary looks like the
     link went to the wrong place, so the panel is opened first and the
     element re-scrolled afterwards — opening it changes the layout, so the
     browser's own jump has already landed in the wrong spot by then.
     Setting `.open` fires the native toggle event, which is what the
     one-open-per-group handler above listens for; do NOT dispatch a second
     one by hand. */
  (function () {
    function openFromHash() {
      var h = location.hash;
      if (!h || h.length < 2) return;
      var t;
      try { t = document.querySelector(h); } catch (e) { return; }
      if (!t) return;
      var d = t.closest ? t.closest('details') : null;
      if (d && !d.open) d.open = true;
      requestAnimationFrame(function () { t.scrollIntoView(); });
    }
    addEventListener('hashchange', openFromHash);
    if (document.readyState === 'complete') openFromHash();
    else addEventListener('load', openFromHash);
  })();

  /* The bank details are PLAIN TEXT — the user's call, 5 Aug: "for bank
     details, keep them as text as it doesnt change". The copy-to-clipboard
     control that shipped with the handoff was removed along with its markup;
     a button that only duplicates selectable static text is a control to
     maintain for no gain. */

  /* ── the entry form ───────────────────────────────────────────────
     A port of the handoff's DCLogic component, behaviour for behaviour:
     the two file inputs are visually hidden and their <label> acts as the
     button, so the chosen filename has to be echoed by hand; validation
     names what is missing rather than relying on the browser's one-field-
     at-a-time bubbles (the form carries `novalidate` for that reason).

     ⚠⚠ THIS FORM DOES NOT POST ANYWHERE YET. It validates, clears and says
     thank you — exactly like the other three form pages on this site — and
     the entry goes nowhere. That is launch blocker B1, and it now covers a
     FOURTH form. Nothing here should go live until a form app is wired in. */
  (function () {
    var form = document.getElementById('lea-entry-form');
    if (!form) return;
    var note = document.getElementById('lea-note');

    function echo(inputId, labelId) {
      var i = document.getElementById(inputId), l = document.getElementById(labelId);
      if (!i || !l) return;
      i.addEventListener('change', function () {
        var f = i.files && i.files[0];
        l.textContent = f ? f.name : 'No file chosen yet';
      });
    }
    echo('s-entry', 'lea-file-entry');
    echo('s-receipt', 'lea-file-receipt');

    function say(msg, ok) {
      if (!note) return;
      note.textContent = msg;
      note.style.color = ok ? '#1a4e5f' : '#7C3B34';
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      function val(n) {
        var el = form.querySelector('[name="' + n + '"]');
        return el ? String(el.value || '').trim() : '';
      }
      function chosen(n) {
        var el = form.querySelector('[name="' + n + '"]');
        return !!(el && el.files && el.files.length);
      }
      var missing = [];
      if (!val('name')) missing.push('your name');
      if (!val('phone')) missing.push('a phone number');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(val('email'))) missing.push('a valid email address');
      if (!chosen('entry')) missing.push('your submission PDF');
      if (!chosen('receipt')) missing.push('your payment receipt');

      if (missing.length) {
        say('Please add ' + missing.slice(0, 2).join(' and ') +
            (missing.length > 2 ? ', and the other required fields.' : '.'), false);
        var first = form.querySelector('[name="name"]');
        for (var i = 0; i < form.elements.length; i++) {
          var el = form.elements[i];
          if (el.name && !String(el.value || '').trim() && el.type !== 'submit') { first = el; break; }
        }
        if (first && first.focus) first.focus();
        return;
      }
      say('Thank you. Your entry is recorded for review.', true);
      form.reset();
      var e1 = document.getElementById('lea-file-entry');
      var e2 = document.getElementById('lea-file-receipt');
      if (e1) e1.textContent = 'No file chosen yet';
      if (e2) e2.textContent = 'No file chosen yet';
    });
  })();

})();


})();
